import React, { useEffect, useState } from 'react'
import Layout from '../../elements/Layout'
import { fetchCustomerSalesReport } from '../../utils/api/api';
import toast from 'react-hot-toast';
import CustomerSales from './CustomerSales';
import * as XLSX from 'xlsx';
import CustomerPieChart from './CustomerPieChart';
import MonthlyChart from './MonthlyChart';

const CustomerSalesReports = () => {
    const [sales, setSales] = useState([]);
    const [loading, setLoading] = useState(false);

    const getSales = async () => {
        setLoading(true)
        try {
            const response = await fetchCustomerSalesReport();
            setSales(response.customer_sales_reports);
        } catch (error) {
            toast.error("Failed to get report")
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSales();
    }, [])

    const exportToExcel = () => {
        if (!sales.customer_sales_list || sales.customer_sales_list.length === 0) {
            toast.error("No data available to export");
            return;
        }

        const data = sales.customer_sales_list.map((list, index) => ({
            "#": index + 1,
            "Customer Name": `${list?.customer?.first_name} ${list?.customer?.last_name}`,
            "Property": list?.property?.title || 'N/A',
            "Amount": list?.amount,
            "Paid Date": list?.paid_date || 'N/A',
            "Status": list?.payment_status
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Sales");

        XLSX.writeFile(workbook, "Customer_Sales_Report.xlsx");
    };

    return (
        <Layout text="Customer report">
            <div className="flex w-full flex-col md:flex-row gap-4">
                <div className="w-full md:w-[65%] border p-2 rounded-lg">
                    <MonthlyChart />
                </div>
                <div className="w-full border md:w-[35%] rounded-lg">
                    <CustomerPieChart />
                </div>
            </div>
            <div className="w-full border rounded-lg mt-4">
                <div className="flex justify-between items-center p-4">
                    <p className="text-[17px] font-medium text-primary">Customer sales list</p>
                    <button
                        onClick={exportToExcel}
                        className="bg-primary text-white px-4 py-1.5 rounded-md text-[14px] transition"
                    >
                        Export to Excel
                    </button>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white h-full flex-grow table-auto">
                        <thead>
                            <tr className="text-primary border-b pb-4 text-[14px] py-3 bg-gray-200 font-medium leading-normal">
                                <th className="py-3 px-2 text-left whitespace-nowrap">#</th>
                                <th className="py-3 px-6 text-left whitespace-nowrap gap-2 flex"> Customer Name</th>
                                <th className="py-3 px-6 text-left whitespace-nowrap">Property</th>
                                <th className="py-3 px-6 text-left whitespace-nowrap">Amount</th>
                                <th className="py-3 px-6 text-left whitespace-nowrap">Paid date</th>
                                <th className="py-3 px-6 text-left whitespace-nowrap">Status</th>
                            </tr>
                        </thead>
                        <tbody className="text-primary text-[14px] font-light">
                            {!sales.customer_sales_list ? (
                                <tr>
                                    <td colSpan="7" className="py-2 px-6 text-center text-gray-500">
                                        {loading ? 'Loading, please wait' : 'No data found'}
                                    </td>
                                </tr>
                            ) : (
                                sales.customer_sales_list.map((list, index) => (
                                    <tr
                                        key={index}
                                        onClick={() => navigate(`/dashboard/customers/${list.customer.id}/view`)}
                                        className={`text-[13px] text-black border-b border-gray-200 cursor-pointer hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                                            }`}
                                    >
                                        <td className="py-2 px-2 text-left whitespace-nowrap">
                                            {index + 1}
                                        </td>
                                        <td className="py-2 px-6 text-left whitespace-nowrap">
                                            <div className="flex gap-2 items-center lowercase">
                                                {list?.customer?.first_name} {list?.customer?.last_name}
                                            </div>
                                        </td>
                                        <td className="py-2 px-6 text-left whitespace-nowrap">
                                            <span>{list?.property?.title || 'N/A'}</span>
                                        </td>
                                        <td className="py-2 px-6 text-left whitespace-nowrap">
                                            <span>{list?.amount}</span>
                                        </td>
                                        <td className="py-2 px-6 text-left whitespace-nowrap">
                                            <span>{list.paid_date || 'N/A'}</span>
                                        </td>
                                        <td className="py-2 px-6 text-left whitespace-nowrap uppercase">
                                            <span>{list.payment_status}</span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    )
}

export default CustomerSalesReports